module.exports = "<p>\n  customer-report works!\n</p>\n"